var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 48,
    viewBox: "0 0 147 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.381 40H9.35211C6.53676 40 4.23096 37.7487 4.23096 35V5C4.23096 2.25125 6.53676 2.11397e-06 9.35211 2.11397e-06H137.381C140.196 2.11397e-06 142.502 2.25125 142.502 5V35C142.502 37.7487 140.196 40 137.381 40Z",
    fill: "#ECEFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7974 10.2435C52.7974 11.0785 52.5414 11.7472 52.0369 12.246C51.4569 12.8372 50.7016 13.1347 49.7759 13.1347C48.8913 13.1347 48.1359 12.8322 47.5162 12.236C46.8953 11.631 46.5854 10.8885 46.5854 9.99975C46.5854 9.111 46.8953 8.3685 47.5162 7.7685C48.1359 7.16725 48.8913 6.86475 49.7759 6.86475C50.2164 6.86475 50.6363 6.9535 51.037 7.1185C51.4365 7.28475 51.7617 7.50975 51.9972 7.78725L51.4621 8.31475C51.0511 7.841 50.4916 7.60725 49.7759 7.60725C49.1307 7.60725 48.5712 7.82725 48.0962 8.271C47.6263 8.716 47.3907 9.29225 47.3907 9.99975C47.3907 10.7072 47.6263 11.2885 48.0962 11.7335C48.5712 12.1722 49.1307 12.3972 49.7759 12.3972C50.4609 12.3972 51.037 12.1722 51.4915 11.7285C51.7911 11.4347 51.9614 11.0297 52.0062 10.5122H49.7759V9.78975H52.7513C52.7872 9.946 52.7974 10.0972 52.7974 10.2435Z",
    fill: "#171A1C",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5177 7.73869H54.7229V9.63869H57.2425V10.3612H54.7229V12.2612H57.5177V12.9974H53.9316V7.00244H57.5177V7.73869Z",
    fill: "#171A1C",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8493 12.9974H60.0581V7.73869H58.3438V7.00244H62.5649V7.73869H60.8493V12.9974Z",
    fill: "#171A1C",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6196 12.9974V7.00244H66.4096V12.9974H65.6196Z",
    fill: "#171A1C",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9113 12.9974H69.1265V7.73869H67.4058V7.00244H71.632V7.73869H69.9113V12.9974Z",
    fill: "#171A1C",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6232 12.226C79.0176 12.8322 78.2674 13.1347 77.3725 13.1347C76.4724 13.1347 75.7222 12.8322 75.1166 12.226C74.5123 11.621 74.2114 10.8785 74.2114 9.99975C74.2114 9.121 74.5123 8.3785 75.1166 7.7735C75.7222 7.16725 76.4724 6.86475 77.3725 6.86475C78.2623 6.86475 79.0125 7.16725 79.6181 7.7785C80.2275 8.3885 80.5284 9.126 80.5284 9.99975C80.5284 10.8785 80.2275 11.621 79.6232 12.226ZM75.7017 11.7235C76.1575 12.1722 76.7118 12.3972 77.3725 12.3972C78.028 12.3972 78.5875 12.1722 79.0381 11.7235C79.4926 11.2747 79.7231 10.6985 79.7231 9.99975C79.7231 9.301 79.4926 8.72475 79.0381 8.276C78.5875 7.82725 78.028 7.60225 77.3725 7.60225C76.7118 7.60225 76.1575 7.82725 75.7017 8.276C75.2472 8.72475 75.0167 9.301 75.0167 9.99975C75.0167 10.6985 75.2472 11.2747 75.7017 11.7235Z",
    fill: "#171A1C",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6387 12.9974V7.00244H82.5989L85.5845 11.6649H85.6191L85.5845 10.5124V7.00244H86.3745V12.9974H85.55L82.4235 8.10494H82.3889L82.4235 9.26244V12.9974H81.6387Z",
    fill: "#171A1C",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0172 21.7526C71.6115 21.7526 69.6463 23.5401 69.6463 26.0064C69.6463 28.4526 71.6115 30.2589 74.0172 30.2589C76.4279 30.2589 78.3932 28.4526 78.3932 26.0064C78.3932 23.5401 76.4279 21.7526 74.0172 21.7526ZM74.0172 28.5839C72.6972 28.5839 71.5616 27.5201 71.5616 26.0064C71.5616 24.4726 72.6972 23.4276 74.0172 23.4276C75.3371 23.4276 76.4779 24.4726 76.4779 26.0064C76.4779 27.5201 75.3371 28.5839 74.0172 28.5839ZM64.4803 21.7526C62.0695 21.7526 60.1094 23.5401 60.1094 26.0064C60.1094 28.4526 62.0695 30.2589 64.4803 30.2589C66.8898 30.2589 68.8512 28.4526 68.8512 26.0064C68.8512 23.5401 66.8898 21.7526 64.4803 21.7526ZM64.4803 28.5839C63.159 28.5839 62.0196 27.5201 62.0196 26.0064C62.0196 24.4726 63.159 23.4276 64.4803 23.4276C65.8003 23.4276 66.9359 24.4726 66.9359 26.0064C66.9359 27.5201 65.8003 28.5839 64.4803 28.5839ZM53.1318 23.0564V24.8639H57.5526C57.4233 25.8739 57.0777 26.6164 56.5476 27.1339C55.9024 27.7589 54.8973 28.4526 53.1318 28.4526C50.4112 28.4526 48.2808 26.3089 48.2808 23.6526C48.2808 20.9964 50.4112 18.8526 53.1318 18.8526C54.6029 18.8526 55.6732 19.4139 56.4631 20.1414L57.7677 18.8676C56.6628 17.8376 55.1931 17.0464 53.1318 17.0464C49.4011 17.0464 46.2656 20.0101 46.2656 23.6526C46.2656 27.2951 49.4011 30.2589 53.1318 30.2589C55.1483 30.2589 56.6628 29.6139 57.8535 28.4039C59.0736 27.2126 59.4539 25.5376 59.4539 24.1851C59.4539 23.7651 59.418 23.3789 59.354 23.0564H53.1318ZM99.5372 24.4576C99.1774 23.5064 98.0674 21.7526 95.8064 21.7526C93.5659 21.7526 91.7005 23.4764 91.7005 26.0064C91.7005 28.3889 93.5467 30.2589 96.0215 30.2589C98.0226 30.2589 99.1774 29.0676 99.6524 28.3739L98.1672 27.4076C97.6718 28.1151 96.9971 28.5839 96.0215 28.5839C95.0523 28.5839 94.3571 28.1501 93.9116 27.2951L99.7382 24.9414L99.5372 24.4576ZM93.5966 25.8739C93.5467 24.2339 94.9012 23.3939 95.8717 23.3939C96.6322 23.3939 97.2774 23.7651 97.4925 24.2964L93.5966 25.8739ZM88.8608 30.0001H90.7761V17.5001H88.8608V30.0001ZM85.7241 22.7001H85.6601C85.2299 22.2026 84.4093 21.7526 83.3697 21.7526C81.1881 21.7526 79.1934 23.6226 79.1934 26.0201C79.1934 28.4039 81.1881 30.2589 83.3697 30.2589C84.4093 30.2589 85.2299 29.8051 85.6601 29.2926H85.7241V29.9026C85.7241 31.5289 84.8343 32.4026 83.3991 32.4026C82.2289 32.4026 81.503 31.5776 81.2034 30.8839L79.5378 31.5626C80.0179 32.6901 81.2892 34.0776 83.3991 34.0776C85.6447 34.0776 87.5396 32.7876 87.5396 29.6489V22.0114H85.7241V22.7001ZM83.5335 28.5839C82.2136 28.5839 81.1087 27.5051 81.1087 26.0201C81.1087 24.5214 82.2136 23.4276 83.5335 23.4276C84.8343 23.4276 85.8598 24.5214 85.8598 26.0201C85.8598 27.5051 84.8343 28.5839 83.5335 28.5839ZM108.504 17.5001H103.923V30.0001H105.834V25.2639H108.504C110.626 25.2639 112.706 23.7651 112.706 21.3814C112.706 18.9989 110.621 17.5001 108.504 17.5001ZM108.554 23.5251H105.834V19.2389H108.554C109.98 19.2389 110.795 20.3951 110.795 21.3814C110.795 22.3489 109.98 23.5251 108.554 23.5251ZM120.362 21.7289C118.982 21.7289 117.547 22.3239 116.957 23.6426L118.652 24.3364C119.017 23.6426 119.688 23.4176 120.397 23.4176C121.388 23.4176 122.393 23.9989 122.408 25.0251V25.1564C122.063 24.9614 121.323 24.6726 120.412 24.6726C118.587 24.6726 116.726 25.6539 116.726 27.4851C116.726 29.1601 118.222 30.2389 119.903 30.2389C121.188 30.2389 121.897 29.6726 122.343 29.0139H122.408V29.9801H124.253V25.1851C124.253 22.9689 122.558 21.7289 120.362 21.7289ZM120.132 28.5789C119.507 28.5789 118.636 28.2764 118.636 27.5201C118.636 26.5526 119.722 26.1814 120.662 26.1814C121.503 26.1814 121.897 26.3626 122.408 26.6014C122.258 27.7589 121.238 28.5789 120.132 28.5789ZM130.975 22.0026L128.779 27.4214H128.714L126.444 22.0026H124.384L127.794 29.5751L125.848 33.7889H127.844L133.1 22.0026H130.975ZM113.756 30.0001H115.671V17.5001H113.756V30.0001Z",
    fill: "#171A1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9188 7.53869C14.618 7.84619 14.4438 8.32494 14.4438 8.94494V31.0599C14.4438 31.6799 14.618 32.1587 14.9188 32.4662L14.9931 32.5337L27.6859 20.1462V19.8537L14.9931 7.46619L14.9188 7.53869Z",
    fill: "url(#paint0_linear_26_291)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9123 24.2773L27.686 20.1461V19.8536L31.9174 15.7223L32.0121 15.7761L37.0232 18.5598C38.4533 19.3498 38.4533 20.6498 37.0232 21.4448L32.0121 24.2236L31.9123 24.2773Z",
    fill: "url(#paint1_linear_26_291)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0121 24.2235L27.686 19.9997L14.9189 32.466C15.3939 32.9535 16.1685 33.0122 17.0493 32.5247L32.0121 24.2235Z",
    fill: "url(#paint2_linear_26_291)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0121 15.7763L17.0493 7.475C16.1685 6.9925 15.3939 7.05125 14.9189 7.53875L27.686 20L32.0121 15.7763Z",
    fill: "url(#paint3_linear_26_291)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_291",
    x: 0.230957,
    y: 0,
    width: 146.271,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.192157 0 0 0 0 0.301961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_291"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_291",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_291",
    x1: 26.5589,
    y1: 31.2902,
    x2: 9.78132,
    y2: 14.1061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_291",
    x1: 38.8854,
    y1: 19.9984,
    x2: 14.1022,
    y2: 19.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_291",
    x1: 29.6597,
    y1: 17.7036,
    x2: 6.9079,
    y2: -5.59945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26_291",
    x1: 11.7052,
    y1: 39.8238,
    x2: 21.8649,
    y2: 29.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.56d36f302e2bb7401cbf6efe02238f81.svg";
export { ForwardRef as ReactComponent };